export function OutlineDummiesIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.39844 16.402L7.20003 17.1988L9.60002 14.7988"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6.99838V4.91999C6 3.8592 6.8592 3 7.91999 3H18.0815C19.1423 3 20.0015 3.8592 20.0015 4.91999V19.0799C20.0015 20.1407 19.1423 20.9999 18.0815 20.9999H15"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9 6.99805H17.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12.9983 11.002H16.9919"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path d="M15 15H16.992" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
      <path
        d="M8.00158 20.9993C10.7639 20.9993 13.0032 18.76 13.0032 15.9977C13.0032 13.2354 10.7639 10.9961 8.00158 10.9961C5.23928 10.9961 3 13.2354 3 15.9977C3 18.76 5.23928 20.9993 8.00158 20.9993Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
